import * as React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import * as constants from "../../../Components/constants";
import style from "./CoursePreview.module.css";
import { Box, Paper, useMediaQuery } from "@mui/material";
import Link from "next/link";

const Img = styled("img")({
  margin: "auto",
  display: "block",
  width: "100%",
  height: "60px",
  borderRadius: "4px",
});
const BASE_URL = constants.BASE_URL;

export default function CoursePreview({ adsId }) {
  const [allCourses, setAllCourses] = React.useState([]);

  React.useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await fetch(`${BASE_URL}/course/all/`);
        const data = await res.json();
        setAllCourses(data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchGroups();
  }, []);

  const matches = useMediaQuery("(max-width:768px)");

  if (!allCourses) return <p>No profile data</p>;

  return (
    <>
      <Paper elevation={0} className={`${style.prtp_ads} p-3`}>
        <Typography
          sx={{ fontWeight: "600" }}
          gutterBottom
          variant="subtitle1"
          component="div"
        >
          Professional Research Training Program (PRTP)
        </Typography>
        <Typography gutterBottom variant="caption" component="div">
          <span className={style.bg_ads}>Ad.</span>{" "}
          <Link href="/prtp">
            <a target="_blank">www.researchrider.com/prtp</a>
          </Link>
        </Typography>
      </Paper>
      <div className={style.overflow}>
        {allCourses.map((course, idx) => {
          return (
            <React.Fragment key={idx}>
              <Box
                sx={{
                  p: 1,
                  margin: "auto",
                  maxWidth: 500,
                  flexGrow: 1,
                }}
              >
                <Grid container spacing={1}>
                  <Grid item>
                    <Link href={`/course/${course.id}`}>
                      <a target="_blank">
                        <ButtonBase
                          sx={{ width: 128, height: 56, cursor: "pointer" }}
                        >
                          <Img alt={course.name} src={course.cover_pic} />
                        </ButtonBase>
                      </a>
                    </Link>
                  </Grid>
                  <Grid item xs={matches ? 5 : 12} sm container>
                    <Grid
                      item
                      xs
                      container
                      direction="column"
                      spacing={2}
                      sx={{ cursor: "pointer" }}
                    >
                      <Grid item xs display="flex">
                        <Link href={`/course/${course.id}`}>
                          <a target="_blank">
                            <Typography
                              className="text-dark"
                              fontWeight={600}
                              gutterBottom
                              variant={matches ? "caption" : "subtitle2"}
                              component="div"
                            >
                              {course.name}
                            </Typography>
                          </a>
                        </Link>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
}
